import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CustomCalendarEvent } from '../warehouse-calendar/warehouse-calendar.component';
import { WarehouseCalendarService } from '../../service/warehouse-calendar.service';
import { ConfirmationService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';
import { InputValidators } from 'src/app/shared/validators/input-validators';


@Component({
  selector: 'warehouse-calendar-edit',
  templateUrl: './warehouse-calendar-edit.component.html',
  styleUrls: ['./warehouse-calendar-edit.component.scss']
})
export class WarehouseCalendarEditComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.EditWarehouseCalendar;
  @Input() checkLicenseNoList: any;

  @Input() calendarEvents: CustomCalendarEvent[] = [];

  @Input() clickDate: any;

  @Input() systemCategory: any;

  @Output() warehouseCalendarImported: EventEmitter<any>;

  confirmationService: ConfirmationService;

  isShowControlledItemModal: boolean;

  showLicenseNoEmpty: boolean;

  isWorkDay: boolean;

  showLengthOverMsg: boolean;

  descr: any;

  memo: any;

  createUser: any;

  updateUser: any;

  form: FormGroup;

  submitted: boolean;

  constructor(
    injector: Injector,
    private warehouseCalendarService: WarehouseCalendarService,
    private fb: FormBuilder) {
    super(injector);
    this.warehouseCalendarImported = new EventEmitter<any>();
    this.isShowControlledItemModal = false;
    this.checkLicenseNoList = null;
    this.showLicenseNoEmpty = false;
    this.isWorkDay = false;
    this.descr = '';
    this.memo = '';
    this.createUser = '';
    this.updateUser = '';
    this.confirmationService = injector.get(ConfirmationService);
    this.form = this.fb.group({
      descr: null
    });
    this.submitted = false;
    this.showLengthOverMsg = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    if (this.calendarEvents.length > 0) {
      if (this.calendarEvents[0].workFlag == '0') {
        this.isWorkDay = true;
      }
      this.descr = this.calendarEvents[0].descr;
      this.memo = this.calendarEvents[0].memo;
      this.createUser = this.calendarEvents[0].createUser;
      this.updateUser = this.calendarEvents[0].updateUser;
    }

  }

  saveBtnClick(event: any): void {
    if (this.showLengthOverMsg) {
      this.submitted = true;
      return;
    }

    var facilityCalendarList: any[] = [
      {
        workDate: this.clickDate,
        workFlag: !this.isWorkDay,
        descr: this.descr,
        memo: this.memo,
        createUser: this.userProfile.userName,
        createDt: new Date(),
        updateUser: this.userProfile.userName,
        updateDt: new Date(),
      }
    ]

    this.updateCalendar(facilityCalendarList);
    this.submitted = false;

  }

  deleteBtnConfirm(event: any): void {
    //確定刪除此行程？
    this.translateService.get('Calendar.Confirm.ConfirmDelete')
    .subscribe({
      next: confirmDelete => {
        //確定取消
        this.translateService.get('Calendar.Confirm.ConfirmCancel')
        .subscribe({
          next: confirmCancel => {
            this.confirmationService.confirm({
              message: confirmDelete,
              header: confirmCancel,
              accept: () => {
                this.deleteCalendar(event);
              },
              reject: () => {
                this.confirmationService.close();
              }
            });
          }
        });
      }
    });
  }

  deleteCalendar(event: any): void {

    var facilityCalendarList: any[] = [
      {
        workDate: this.clickDate,
        workFlag: true,
        descr: '',
        memo: '',
        createUser: this.userProfile.userName,
        createDt: new Date(),
        updateUser: this.userProfile.userName,
        updateDt: new Date(),
      }
    ]

    this.updateCalendar(facilityCalendarList);
  }

  updateCalendar(facilityCalendarList: any[]): void {

    var params: any = {
      facility: this.laasSetting.facility,
      userId: this.userProfile.userName,
      facilityCalendar: facilityCalendarList,
      systemCategory: this.systemCategory
    };

    this.warehouseCalendarService.updateCalendar(params).subscribe({
      next: result => {
        this.warehouseCalendarImported.emit({ originalEvent: event });
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.toastService.error(error.error);
        }
      }
    });

  }

  isShowOverLengthMsg(control: AbstractControl | null, submitted: boolean, maxLength: any): boolean {

    this.showLengthOverMsg = InputValidators.isShowOverLengthMsg(control, submitted, maxLength, this.form);
    return this.showLengthOverMsg;

  }

}

